import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// UserManagment
import TypeJob from '@/views/Settings/Typejob'
import System from '@/views/Settings/System'
import CronJob from '@/views/Settings/CronJob'
import AppAdvertising from '@/views/Settings/AppAdvertising'
import TypeApLicense from '@/views/Settings/ApLicense'
import GlTransRules from '@/views/Settings/GlTransRules'
import HardWareStore from '@/views/Settings/HardWareStore'
import HolidayCalendar from '@/views/Settings/HolidayCalendar'
import EmploymentTitle from '@/views/Settings/EmploymentTitle'
import EmployeesTimeAllowance from '@/views/Settings/EmployeesTimeAllowance'
import Signature from '@/views/Settings/signature'
import InsuranceType from '@/views/Settings/InsuranceType'
import Apliance from '@/views/Settings/Apliance'
import UtilityTenantInvoice from  '@/views/Settings/UtilityTenantInvoice'
 import AnnualLeave from  '@/views/Settings/AnnualLeave'
import FieldRule from  '@/views/Settings/FieldRule'
import BankByGroup from '@/views/Settings/BankByGroup'
import VendorType from '@/views/Settings/VendorType'
import GLChart from '@/views/Settings/GLChart'
import GLAcctSubType from '@/views/Settings/GLAcctSubType'
import ApModuleGlAcctRange from '@/views/Settings/ApModuleGlAcctRange'
import StateCountyCity from '@/views/Settings/StateCountyCity'
const userManagment = [
  {
    path: "/Settings",
    element: <SandBox />,
    children: [
      {
        path: "TypeJob",
        element: docLazyFn(<TypeJob />),
      },
      {
         path: "System",
        element: docLazyFn(<System />),
      },
       {
         path: "CronJob",
        element: docLazyFn(<CronJob />),
      },
      {
        path: "AppAdvertising",
        element: docLazyFn(<AppAdvertising />),
      },
       {
        path: "TypeApLicense",
        element: docLazyFn(<TypeApLicense />),
      },{
        path: "GlTransRules",
        element: docLazyFn(<GlTransRules />), 
      },
      {
        path: "HardWareStore",
        element: docLazyFn(<HardWareStore />),
      },
      {
        path: "HolidayCalendar",
        element: docLazyFn(<HolidayCalendar />),
      },
      {
        path: "EmploymentTitle",
        element: docLazyFn(<EmploymentTitle />),
      },
       {
        path: "EmployeesTimeAllowance",
        element: docLazyFn(<EmployeesTimeAllowance />),
      },
       {
        path: "Signature",
        element: docLazyFn(<Signature />),
      },
      {
        path: "InsuranceType",
        element: docLazyFn(<InsuranceType />),
      },
      {
        path: "Apliance",
        element: docLazyFn(<Apliance />),
      },
       {
        path: "UtilityTenantInvoice",
        element: docLazyFn(<UtilityTenantInvoice />),
      },
      {
        path: "AnnualLeave",
        element: docLazyFn(<AnnualLeave />),
      },
      {
        path: "FieldRule",
        element: docLazyFn(<FieldRule />),
      },
         {
        path: "BankByGroup",
        element: docLazyFn(<BankByGroup />),
      },
      {
        path: "VendorType",
        element: docLazyFn(<VendorType />),
      },{
        path: "GLChart",
        element: docLazyFn(<GLChart />),
      },{
        path: "GLAcctSubType",
        element: docLazyFn(<GLAcctSubType />),
      },
      {
        path: "ApModuleGlAcctRange",
        element: docLazyFn(<ApModuleGlAcctRange />),
      },
      {
        path: "StateCountyCity",
        element: docLazyFn(<StateCountyCity />),
      },
    ],
  }
];

export default userManagment;
